import type en from "../en/voicelab";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  metaTitle: "Labo des voix",
  title: "Labo des voix",
  description: "Comparez les fournisseurs de synthèse vocale sur vos propres phrases — darija marocaine, égyptien, saoudien, français, anglais… — puis choisissez la voix de chaque langue dans les appels IA, séparément pour les personas féminines et masculines.",
  back: "IA et crédits",
  open: "Ouvrir le labo des voix",

  providersTitle: "Fournisseurs",
  providersDesc: "Collez une clé API pour chaque fournisseur à tester. Les clés sont chiffrées sur le serveur et ne sont plus jamais affichées.",
  keyLabel: "Clé API",
  keyPlaceholder: "Coller une nouvelle clé",
  keySaved: "Clé enregistrée ({hint})",
  keyEnv: "Clé de l’environnement serveur ({hint})",
  keyMissing: "Aucune clé",
  saveKey: "Enregistrer",
  removeKey: "Supprimer la clé",
  tune_stability: "Stabilité",
  tune_similarityBoost: "Similarité",
  tune_style: "Style",
  tune_speed: "Vitesse",
  tuneReset: "Réinitialiser",
  tuneHint: "Conversation naturelle : stabilité ≈ 0,5 (plus bas = plus expressif, plus haut = plus régulier), similarité ≈ 0,75, style 0 (plus haut ajoute de la latence), vitesse 0,95–1,05. Eleven v3 n’accepte que 0, 0,5 ou 1 pour la stabilité. Ces réglages sont enregistrés avec la voix quand vous appuyez sur « Utiliser ».",
  customTuning: "Ajuster les réglages de la voix",
  ownSettingsHint: "Chaque voix utilise ses propres réglages enregistrés — ceux de ses extraits. Activez « Ajuster les réglages de la voix » seulement pour les changer.",
  fixesTitle: "Corrections de prononciation · {lang}",
  fixesHint: "Quand un mot est mal lu (ex. الخلاص en darija lu comme en arabe standard), écrivez-le tel qu’il doit sonner — ajoutez un soukoun (ْ) ou une chadda (ّ), retirez la voyelle ou écrivez-le phonétiquement. Écouter les essaie avant l’enregistrement ; une fois enregistrées, les appels les utilisent aussi.",
  fixWord: "Mot",
  fixSay: "Prononcer comme",
  fixAdd: "+ Ajouter un mot",
  verifiedWith: "vérifiée avec {model}",
  voiceFor: "Voix pour",
  defaultFor: "Toutes les personas ({gender}, par défaut)",
  colPersonas: "Personas",
  usesDefault: "utilise la voix {gender} par défaut",
  modelLabel: "Modèle",
  getKey: "Obtenir une clé",
  saved: "Enregistré.",

  labTitle: "Écouter et comparer",
  labDesc: "Choisissez une langue ou un dialecte, un genre et un fournisseur, chargez ses voix et appuyez sur Écouter. Le temps indique la durée de réponse du fournisseur (plus bas = mieux pour les appels).",
  language: "Langue / dialecte",
  gender: "Persona",
  female: "Femme",
  male: "Homme",
  sampleText: "Phrase à lire",
  resetSample: "Phrase d’exemple",
  provider: "Fournisseur",
  loadVoices: "Charger les voix",
  searchPlaceholder: "Filtrer par nom ou accent",
  noVoices: "Aucune voix pour ce filtre.",
  noKey: "Ajoutez d’abord une clé pour ce fournisseur.",
  listen: "Écouter",
  stop: "Arrêter",
  preview: "Extrait du fournisseur",
  latency: "{ms} ms",
  use: "Utiliser pour {lang} · {gender}",
  inUse: "Utilisée",
  sourceLibrary: "Bibliothèque",
  sourceAccount: "Mes voix",
  sourceBuiltin: "Intégrée",
  voiceCount: "{count} voix",

  assignmentsTitle: "Voix utilisées dans les appels",
  assignmentsDesc: "Un dialecte sans voix propre utilise la ligne arabe (الفصحى). Une persona n’a jamais une voix de l’autre genre ; sans voix définie, les appels utilisent les voix du navigateur du bon genre ou les sous-titres.",
  colLanguage: "Langue",
  notSet: "Non définie",
  clear: "Retirer",
  fallsBack: "Utilise {lang}",
};

export default fr;
